import { getLinks, AcceptedLinksStarts } from '@cinch-nx/data-storyblok'
import { policiesStaticPaths } from './data/policies-static-paths'
import { GetStaticPathsResult } from 'next'

export function getStaticPathsGenerator(slug: string) {
  return async (): Promise<GetStaticPathsResult> => {
    try {
      const links = await getLinks(slug as AcceptedLinksStarts)
      const filteredLinks = Object.fromEntries(
        Object.entries(links).filter(([, link]) => !link.slug.includes(slug)),
      )
      const paths = policiesStaticPaths({ links: filteredLinks })
      return { paths, fallback: 'blocking' }
    } catch {
      return { paths: [], fallback: 'blocking' }
    }
  }
}
